module.exports = __webpack_public_path__ + "img/New Chat.49f4468f.svg";